// Download Item

export default function DownloadItem({ title, type, fileUrl }) {
  return (
    <a
      href={fileUrl}
      download
      className="group flex items-center justify-between border-b border-white/15 py-6 text-left transition hover:border-amber-flame-500/60"
    >
      <span className="font-serif text-xl text-white md:text-2xl">
        {title} <span className="text-slate-400">— {type}</span>
      </span>

      <span
        aria-hidden="true"
        className="ml-6 text-slate-500 transition group-hover:text-amber-flame-400"
      >
        ↓
      </span>
    </a>
  );
}